import {createSlice} from '@reduxjs/toolkit'


const initialState = {
    CredenceAccountNumber : "",
    LastName : "",
    SSN : "",
     token : "",
     refreshToken :""
 
}

export const AuthenticationSlice = createSlice({
    name : 'Authentication',
    initialState,
    reducers : {
        LoginSucessfull : (state,action)=>{
         
          state.CredenceAccountNumber= action.payload.CredenceAccountNumber;
          state.LastName= action.payload.LastName;
          state.SSN= action.payload.SSN;
          state.token =action.payload.token;
          state.refreshToken = action.payload.refreshToken;
         
        },
        Logout : (state,action)=>{ 
             state.CredenceAccountNumber = "";
  state.LastName = "";
  state.SSN = "";
  state.token = "";
  state.refreshToken = "";
       },
    }
})

export const { LoginSucessfull,Logout} = AuthenticationSlice.actions;
export default AuthenticationSlice.reducer;